export class CategoryAddModel {
    id: number;
    name: any = null;
    photo: string;
    top_flag: number = 0;
    status: boolean; 
    title:any;
}
